import React, { useState, useEffect } from 'react';
import '../components/SensorContainer.css';

const CsvDownloadContainer = () => {
  const [csvFiles, setCsvFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadCsvFiles();
  }, []);

  const loadCsvFiles = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${window.location.protocol}//${window.location.hostname}:8000/csv-files`);
      const files = await response.json();
      setCsvFiles(files);
    } catch (error) {
      console.error('CSV 파일 목록 로드 실패:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileSelect = (filename) => {
    setSelectedFiles(prev => 
      prev.includes(filename) 
        ? prev.filter(f => f !== filename)
        : [...prev, filename]
    );
  };

  const handleSelectAll = () => {
    if (selectedFiles.length === csvFiles.length) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles(csvFiles.map(f => f.filename));
    }
  };

  const handleDownload = async () => {
    if (selectedFiles.length === 0) {
      alert('다운로드할 파일을 선택해주세요.');
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${window.location.protocol}//${window.location.hostname}:8000/merge-csv`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ filenames: selectedFiles }),
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `merged_${selectedFiles.length}files.zip`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        alert('다운로드 실패');
      }
    } catch (error) {
      console.error('다운로드 오류:', error);
      alert('다운로드 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className="container">
      <div className="filterContainer">
        <h3>월별 CSV 파일 다운로드</h3>
        <button
          onClick={loadCsvFiles}
          disabled={loading}
          className={`button buttonPrimary ${loading ? 'buttonDisabled' : ''}`}
        >
          {loading ? '로딩중...' : '새로고침'}
        </button>
        <button
          onClick={handleSelectAll}
          className="button buttonSecondary"
        >
          {selectedFiles.length === csvFiles.length ? '전체 해제' : '전체 선택'}
        </button>
        <button
          onClick={handleDownload}
          disabled={loading || selectedFiles.length === 0}
          className={`button buttonSuccess ${loading || selectedFiles.length === 0 ? 'buttonDisabled' : ''}`}
        >
          {loading ? '처리중...' : `선택된 ${selectedFiles.length}개 파일 다운로드`}
        </button>
      </div>

      <div style={{ width: '90%', margin: '0 auto' }}>
        <div className="statusSummary">
          <span>총 {csvFiles.length}개 파일 | 선택됨: {selectedFiles.length}개</span>
        </div>

        <div className="tableScrollWrapper">
          {csvFiles.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              {loading ? '로딩중...' : '저장된 CSV 파일이 없습니다.'}
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ border: '1px solid #ddd', padding: '8px', width: '50px' }}>선택</th>
                  <th style={{ border: '1px solid #ddd', padding: '8px' }}>파일명</th>
                  <th style={{ border: '1px solid #ddd', padding: '8px' }}>크기</th>
                  <th style={{ border: '1px solid #ddd', padding: '8px' }}>생성일</th>
                </tr>
              </thead>
              <tbody>
                {csvFiles.map((file, index) => (
                  <tr key={index}>
                    <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={selectedFiles.includes(file.filename)}
                        onChange={() => handleFileSelect(file.filename)}
                      />
                    </td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{file.filename}</td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formatFileSize(file.size)}</td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                      {new Date(file.created).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default CsvDownloadContainer;